"use client";

import React, { useState } from "react";
import { useRouter } from "next/navigation";
import Link from "next/link";

export default function BookSignup() {
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState("");
  const router = useRouter();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError("");

    try {
      const response = await fetch("/api/mailchimp/subscribe", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, tags: ["book"] }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Failed to subscribe");
      }

      // Redirect to thank you page
      router.push("/book/thank-you");
    } catch (err) {
      setError(
        err instanceof Error
          ? err.message
          : "Something went wrong. Please try again.",
      );
      setIsSubmitting(false);
    }
  };

  return (
    <div className="space-y-4">
      <div className="mb-6">
        <p className="text-xl md:text-2xl font-medium text-gray-900 dark:text-gray-100 mb-2">
          Get your PDF copy of the Book
        </p>
        <p className="text-base md:text-lg text-gray-700 dark:text-gray-300">
          Enter your email and get the book right away.
        </p>
      </div>
      <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-4">
        <div className="flex-1">
          <label htmlFor="book-email" className="sr-only">
            Email Address
          </label>
          <input
            type="email"
            id="book-email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full px-4 py-2.5 rounded-lg bg-white/50 dark:bg-dark/50 
                     border border-gray-light/20 dark:border-gray-dark/20
                     focus:outline-none focus:ring-2 focus:ring-dark dark:focus:ring-white"
            placeholder="Enter your email..."
            required
            disabled={isSubmitting}
          />
        </div>

        <button
          type="submit"
          disabled={isSubmitting}
          className="px-6 py-2.5 rounded-full border-2 border-current group relative inline-block overflow-hidden text-center hover:scale-105 transition-transform duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {isSubmitting ? "Signing Up..." : "Sign Up!"}
        </button>
      </form>

      {error && <p className="text-sm text-red-500">{error}</p>}
      <p className="text-base text-gray-600 dark:text-gray-300 mt-4">
        This will also sign you up for the{" "}
        <Link
          href="/newsletter"
          className="underline hover:text-gray-800 dark:hover:text-gray-200 font-medium"
        >
          We Built a Thing
        </Link>{" "}
        newsletter.
      </p>
    </div>
  );
}
